import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetSmartInstallmentsSummariesInput } from '../../domain/dtos/get-smart-installments-summaries-input'
import { QueryKey } from '../../domain/enums/query-keys'
import { GetSmartInstallmentsSummaries } from '../../usecases/get-smart-installments-summaries'

export const useGetSmartInstallmentsSummaries = (input: GetSmartInstallmentsSummariesInput, isLoading: boolean) => {
  const container = useContainer()

  const offerIds = input.offers.filter(({ id }) => id !== 'all').map(({ id }) => id)
  const enabled = !isLoading && offerIds.length > 0
  const initialData = {
    count: 0,
    totalPaid: 0,
    totalScheduled: 0,
    totalUnpaid: 0,
  }

  return useQuery(
    [QueryKey.getSmartInstallmentsSummaries],
    ({ signal }) => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetSmartInstallmentsSummaries(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      initialData,
      enabled,
    },
  )
}
